// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `swiper-container {
  height: auto;
}
@media (max-width: 992px) {
  swiper-container {
    height: 55vh;
  }
}
swiper-container swiper-slide {
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
  border-radius: 26px;
}

.title {
  font-family: AppFontMedium;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.06em;
  text-align: center;
  color: var(--color-black);
  padding: 0 20px;
  text-transform: uppercase;
  font-weight: bold;
}

.info {
  font-family: AppFont;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
  padding: 0 10px 15px;
}

.grey {
  color: var(--color-black);
  opacity: 0.6;
}

.buttons_wrap {
  padding: 0 40px;
}
@media (max-width: 992px) {
  .buttons_wrap {
    padding: 20px;
    margin-bottom: 20px;
  }
}
@media (max-width: 400px) {
  .buttons_wrap {
    padding-top: 0px;
  }
}
.buttons_wrap ion-button {
  width: 100%;
  margin-bottom: 10px;
  text-transform: uppercase;
}
.buttons_wrap .cancel {
  --background: transparent;
  --border-width: 0px;
  color: var(--color-black);
  text-decoration: underline;
}

ion-slides {
  --bullet-background-active: var(--ion-color-text) !important;
}

.second_box {
  width: 100%;
  padding: 0 25px 20px;
}

.box {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 20px;
}
.box:last-child {
  margin-bottom: 0;
}
.box ion-img {
  width: 30%;
}
@media (max-width: 992px) {
  .box ion-img {
    width: 8%;
  }
}
.box .text-title {
  margin-left: 20px;
  font-weight: bold;
  font-size: 13px;
  font-family: AppFont;
  text-transform: uppercase;
}
.box .text {
  text-transform: uppercase;
  margin-left: 20px;
  font-family: AppFont;
  text-align: start;
  font-size: 11px;
}

swiper-container {
  --swiper-pagination-bottom: 85px !important;
  --swiper-pagination-color: var(--ion-color-secondary);
}
@media (max-width: 992px) {
  swiper-container {
    --swiper-pagination-bottom: 0 !important;
  }
}
swiper-container swiper-slide {
  width: 100%;
  max-width: 100% !important;
  height: calc(100% - 20px);
  margin: 0px 0px 20px;
}

.slide-info {
  padding-top: 30px;
}
@media (max-width: 992px) {
  .slide-info {
    position: absolute;
    top: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/loyalty-components/loyalty-slider/loyalty-slider.component.scss"],"names":[],"mappings":"AAAA;EAEI,YAAA;AAAJ;AACK;EAHL;IAIS,YAAA;EAEP;AACF;AADI;EACI,YAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,sBAAA;EAEA,mBAAA;AAER;;AAGA;EACI,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,oBAAA;AAAJ;;AAEA;EACI,yBAAA;EAEA,YAAA;AAAJ;;AAGA;EACI,eAAA;AAAJ;AACK;EAFL;IAGQ,aAAA;IACA,mBAAA;EAEN;AACF;AADI;EANJ;IAOQ,gBAAA;EAIN;AACF;AAHI;EACI,WAAA;EACA,mBAAA;EACA,yBAAA;AAKR;AAFI;EACI,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,0BAAA;AAIR;;AADA;EACI,4DAAA;AAIJ;;AADA;EACI,WAAA;EACA,oBAAA;AAIJ;;AAAA;EACI,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;AAGJ;AADI;EACI,gBAAA;AAGR;AAAI;EACI,UAAA;AAER;AADQ;EAFJ;IAGQ,SAAA;EAIV;AACF;AAFI;EACI,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,yBAAA;AAIR;AAFI;EACI,yBAAA;EACA,iBAAA;EACA,oBAAA;EAEA,iBAAA;EACA,eAAA;AAGR;;AAAA;EAGI,2CAAA;EAIA,qDAAA;AAFJ;AADO;EAJP;IAKU,wCAAA;EAIR;AACF;AAFI;EACE,WAAA;EACA,0BAAA;EACA,yBAAA;EACA,oBAAA;AAIN;;AAAE;EACE,iBAAA;AAGJ;AAFU;EAFR;IAGU,kBAAA;IACA,MAAA;EAKV;AACF","sourcesContent":["swiper-container {\n\n    height: auto;\n     @media (max-width: 992px) {\n         height: 55vh;\n    }\n    swiper-slide  {\n        height: 100%;\n        display: flex;\n        justify-content: space-around;\n        align-items: center;\n        flex-direction: column;\n        // border: 1px solid var(--color-black);\n        border-radius: 26px;\n    }\n    // margin: 20px;\n}\n\n.title {\n    font-family: AppFontMedium;\n    font-size: 18px;\n    line-height: 22px;\n    letter-spacing: 0.06em;\n    text-align: center;\n    color: var(--color-black);\n    padding: 0 20px;\n    text-transform: uppercase;\n    font-weight: bold;\n}\n\n.info {\n    font-family: AppFont;\n    font-size: 13px;\n    line-height: 16px;\n    letter-spacing: 0em;\n    text-align: center;\n    color: var(--color-black);\n    text-transform: uppercase;\n    padding: 0 10px 15px;\n}\n.grey {\n    color: var(--color-black);\n\n    opacity: 0.6;\n}\n\n.buttons_wrap {\n    padding: 0 40px;\n     @media (max-width: 992px) {\n        padding: 20px;\n        margin-bottom: 20px;\n     }\n    @media (max-width: 400px) {\n        padding-top: 0px;\n    }\n    ion-button {\n        width: 100%;\n        margin-bottom: 10px;\n        text-transform: uppercase;\n\n    }\n    .cancel {\n        --background: transparent;\n        --border-width: 0px;\n        color: var(--color-black);\n        text-decoration: underline;\n    }\n}\nion-slides {\n    --bullet-background-active: var(--ion-color-text) !important;\n}\n\n.second_box {\n    width: 100%;\n    padding: 0 25px 20px;\n\n}\n\n.box {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    margin-bottom: 20px;\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n\n    ion-img {\n        width: 30%;\n        @media (max-width: 992px) {\n            width: 8%;\n        }\n    }\n    .text-title {\n        margin-left: 20px;\n        font-weight: bold;\n        font-size: 13px;\n        font-family: AppFont;\n        text-transform: uppercase;\n    }\n    .text {\n        text-transform: uppercase;\n        margin-left: 20px;\n        font-family: AppFont;\n\n        text-align: start;\n        font-size: 11px;\n    }\n}\nswiper-container {\n\n\n    --swiper-pagination-bottom: 85px !important;\n       @media (max-width: 992px) {\n          --swiper-pagination-bottom: 0 !important;\n    }\n    --swiper-pagination-color: var(--ion-color-secondary);\n    swiper-slide {\n      width: 100%;\n      max-width: 100% !important;\n      height: calc(100% - 20px);\n      margin: 0px 0px 20px;\n    //   padding: 20px;\n    }\n  }\n  .slide-info {\n    padding-top: 30px;\n          @media (max-width: 992px) {\n            position: absolute;\n            top: 0;\n    }\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
